module.exports = "/images/hands@3x.png?97fe184c973b1fd638fee4f2a9269db7";